module.exports = __webpack_public_path__ + "img/introducer-en-ca.20cc2556.jpg";